import * as React from "react";
import { PageBase } from "../../components";
import { Card, Button, Icon, Colors } from "@blueprintjs/core";
import styled from "styled-components";
import { ETLCodes } from "../../locales";
import { useTl } from "../../hooks";
import { useAuth } from "../../contexts";
import { IconNames } from "@blueprintjs/icons";

export interface IUnauthorizedPageProps {}

const MainContainer = styled.div`
  flex: 1;
  justify-content: center;
  align-items: center;
  display: flex;
`;

const StyledCard = styled(Card)`
  width: 400px;
  height: 300px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: column;
`;

const StyledH2 = styled.h2`
  text-align: center;
`;

export const UnauthorizedPage: React.FunctionComponent<IUnauthorizedPageProps> = (props) => {
  const { t } = useTl();
  const { logout } = useAuth();
  return (
    <PageBase withCard={false}>
      <MainContainer>
        <StyledCard>
          <Icon icon={IconNames.DELETE} iconSize={40} color={Colors.RED3} />
          <StyledH2>{t(ETLCodes.NotAuthorized)}</StyledH2>
          <h3>{t(ETLCodes.ReferToAdminOrRelogin)}</h3>
          <Button text={t(ETLCodes.Logout)} onClick={() => logout("NORMAL")} intent="primary" icon={IconNames.LOG_OUT}/>
        </StyledCard>
      </MainContainer>
    </PageBase>
  );
};
